import * as L from 'leaflet';
import { Marker } from 'react-leaflet';
import type { IStopPoint } from '../../../../../models/stop-point.model';
import { TranslationService } from '../../../../../services/translation.service';
import './style.scss';

function StopPointMarker({ stopPoint }: { stopPoint: IStopPoint }) {
  if (!stopPoint.latitude || !stopPoint.longitude) {
    return null;
  }

  const icon = L.divIcon({
    className: 'div-icon stop-point-marker',
    iconSize: [42, 55],
    iconAnchor: [21, 55],
    html: `<div class="position-relative">
                         <span class="visually-hidden">${TranslationService.get('common.platform')}</span>
                         <span class="position-absolute fg-white w-100" style="margin-top: 7px">${stopPoint.platform}</span>
                         <img src="/icons/map-marker-empty.svg" alt="" class="w-100 h-100" />
                       </div>`,
  });

  return <Marker key={stopPoint.gid} icon={icon} position={[stopPoint.latitude, stopPoint.longitude]} />;
}

export default StopPointMarker;
